import emptyFieldValidate from "../../shared/empty.validate";
import usernameValidate from "../../shared/username.validate";

export type TErrors = {
  username: string | undefined;
  name: string | undefined;
  lastname: string | undefined;
};

const updateProfile = (FormValues: Record<string, any>) => {
  let errors: TErrors = {
    username: undefined,
    name: undefined,
    lastname: undefined,
  };

  errors.username = usernameValidate(FormValues.username);

  errors.name = emptyFieldValidate(FormValues.name, "Username");

  errors.lastname = emptyFieldValidate(FormValues.lastname, "Last Name");

  return errors;
};

export default updateProfile;
